export enum ManualPage {
  Home = 'home',
  Bookings = 'bookings',
  Media = 'media',
  MediaTransfer = 'media-transfer',
  Widgets = 'widgets',
  Reach = 'reach',
  Campaign = 'campaign',
  Forecast = 'forecast',
  PeopleCounter = 'people-counter',
  Poi = 'poi',
  Sms = 'sms',
  Channels = 'channels',
  Devices = 'devices',
  Clients = 'clients',
  ContactPersons = 'contact-persons',
  Permissions = 'permissions',
  Users = 'users',
}
